import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";

const DeleteModal = ({
  isOpen,
  toggle,
  onConfirm,
  title,
  body,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>

          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{title || "Are you sure?"}</h4>
            <p className="text-muted mx-4 mb-0">
              {body || "Are you sure you want to remove this record?"}
            </p>
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            onClick={toggle}
          >
            Close
          </button>

          <button
            type="button"
            className="btn w-sm btn-danger"
            onClick={onConfirm}
          >
            Yes, Delete It!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DeleteModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
};

export default DeleteModal;